<template>
    <div class="wrap">
        <div class="container lnb">
            <div class="contents_wrap">
                <div class="contents">
                    <div class="title">{{ title }}</div>
                    <div class="table_wrap">
                        <div class="table_search">
                            <el-row>
                                <el-col :span="12">
                                    <span class="t_s_title">발생일</span>
                                    <span class="el-checkbox-group">
                                        <el-date-picker
                                          v-model="filterDate"
                                          type="daterange"
                                          range-separator="~"
                                          value-format="yyyy-MM-dd"
                                          start-placeholder="시작일"
                                          end-placeholder="종료일"
                                          >
                                        </el-date-picker>
                                    </span>
                                </el-col>
                            </el-row>
                        </div>
                        <div class="search_btn_wrap text_center">
                            <el-button type="primary" @click="[getList(), page=1]">검색</el-button>
                        </div>
                        <el-table :data="tableData" style="width: 100%" empty-text="데이터가 없습니다." v-loading="tableLoading">
                            <el-table-column
                                class="table_no"
                                type="index"
                                label="NO."
                                width="100"
                                class-name="num"
                                :index="tableIndex"
                            ></el-table-column>
                            <el-table-column  label="사유">
                                <template slot-scope="scope">
                                    {{ scope.row.ncl_message }}
                                </template>
                            </el-table-column>
                            <el-table-column width="300" label="발생일">
                                <template slot-scope="scope">
                                    {{ returnDateFormat(scope.row.created_at,"yyyy-MM-DD HH:mm") }}
                                </template>
                            </el-table-column>
                            <el-table-column width="200" label="옵션">
                                <template slot-scope="scope">
                                    <el-button size="mini" type="danger" @click="deleteLog(scope.row.ncl_idx)">삭제</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pagnation_wrap">
                        <el-pagination
                          :page-size="10"
                          :pager-count="filterPagnation.pagerCount"
                          layout="prev, pager, next"
                          :current-page.sync="page"
                          :total="listTotal"
                          @current-change="getList"
                        >
                        </el-pagination>
                    </div>
                </div>
                <page-footer></page-footer>
            </div>
        </div>
    </div>
</template>


<script>
import dateMixins from "@/mixins/dateMixins"
import VuxAlert from '@/mixins/vux-alert';
export default {
    name: "Alert",
    mixins: [dateMixins,VuxAlert],
    components: {},
    props: {},
    data() {
        return {
            title: this.$route.meta.title,
            filterDate:null,
            tableData: [],
            pagnation: {
              size: 10,
              pagerCount: 11,
              page: 1,
            },
            page:0,
            lastPage:0,
            listTotal:0,
        };
    },
    beforeRouterEnter() {},
    created() {
        this.getList();
    },
    mounted() {},
    beforeUnmount() {},
    unmounted() {},
    computed: {
        tableFilter() {
            return this.tableData
        },
        filterPagnation() {
          return {
            size: 10,
            pagerCount: 11,
            total: this.tableFilter.length,
            page: 1
          }
        }
    },
    methods: {
        getList() {
        this.tableLoading = true;
        let params = {
          page: this.page,
          ip : 1,
          sp:10,
        }
        if(this.filterDate != null && this.filterDate.length> 0) {
          params.crsd = this.filterDate[0];
          params.cred = this.filterDate[1];
        }
        
        this.$api.$alert.getAlert(params).then( res => res.Data.result).then(res => {
          if(res.Info.Type === 1) {
            this.tableData = res.List;
            this.lastPage = res.Page.last_page;
            this.listTotal = res.Page.total;
          }else{
            this.tableData = [];
            this.page = 1;
            this.lastPage = 0;
            this.listTotal = 0;

          }
          this.tableLoading = false;
        })
      },
      tableIndex(index) {
        return   this.listTotal - this.pagnation.size * (this.page - 1) - index
      },
      deleteLog(key){
        let alertParams = {'element' : this , 'key' : key};
        this.listDeleteAlert(alertParams);
      },
      dataDelete(key){
        let params = {'ncl_idx' : key}
        this.$api.$alert.deleteAlert(params).then( res => res.Data.result).then(res => {
          if(res.Info.Type === 1) {
            this.page = 1
            let alertParams = {'element' : this  };
            this.deleteAlert(alertParams);
          }else{
            this.errorAlert(res.reason);
          }
        })
      },
    },
    watch: {},
};
</script>
